var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBonus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2188 8.8125H4.78125C4.41881 8.8125 4.125 9.10631 4.125 9.46875V12.0938C4.125 12.4562 4.41881 12.75 4.78125 12.75H19.2188C19.5812 12.75 19.875 12.4562 19.875 12.0938V9.46875C19.875 9.10631 19.5812 8.8125 19.2188 8.8125Z",
    stroke: "#383733",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5625 12.75V18.6562C18.5625 18.8303 18.4934 18.9972 18.3703 19.1203C18.2472 19.2434 18.0803 19.3125 17.9062 19.3125H6.09375C5.9197 19.3125 5.75278 19.2434 5.62971 19.1203C5.50664 18.9972 5.4375 18.8303 5.4375 18.6562V12.75",
    stroke: "#383733",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 8.8125V19.3125",
    stroke: "#383733",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7123 7.88449C14.7842 8.81257 12 8.81257 12 8.81257C12 8.81257 12 6.02833 12.9281 5.10026C13.2974 4.73139 13.798 4.52427 14.32 4.52441C14.8419 4.52456 15.3424 4.73197 15.7115 5.10105C16.0806 5.47012 16.288 5.97065 16.2882 6.4926C16.2883 7.01456 16.0812 7.5152 15.7123 7.88449V7.88449Z",
    stroke: "#383733",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.28776 7.88449C9.21583 8.81257 12.0001 8.81257 12.0001 8.81257C12.0001 8.81257 12.0001 6.02833 11.072 5.10026C10.7027 4.73139 10.2021 4.52427 9.6801 4.52441C9.15815 4.52456 8.65762 4.73197 8.28855 5.10105C7.91947 5.47012 7.71206 5.97065 7.71191 6.4926C7.71177 7.01456 7.91889 7.5152 8.28776 7.88449V7.88449Z",
    stroke: "#383733",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBonus);
export default __webpack_public_path__ + "static/media/bonus.e7298a2cac2b3577ec8b578b0048bf6f.svg";
export { ForwardRef as ReactComponent };